import rest from '../rest';
import yearData from './yearsResponse';

const years = [rest.get('/api/v2/contracts/years', (req, res, ctx) => res(ctx.json(yearData)))];

export default years;
